import React, { useState } from "react";
import "../home/home.css";
import { faChartLine } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function CustomTokenAnalyzer() {
  const [customSymbol, setCustomSymbol] = useState("");
  const [customLoading, setCustomLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  const isLocal = window.location.hostname === "localhost";
  const baseUrl = isLocal
    ? "http://localhost:5000"
    : "https://www.trendscout.club";

  const handleAnalyze = async () => {
    if (!customSymbol.trim()) return;

    setCustomLoading(true);
    setError(null);
    setResult(null);

    try {
      const res = await fetch(`${baseUrl}/api/analyze-token`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ symbol: customSymbol.trim().toUpperCase() }),
      });

      const data = await res.json();

      if (res.ok && data && data.token) {
        setResult(data);
        setCustomSymbol("");
      } else {
        throw new Error(data.error || "Unknown error during analysis");
      }
    } catch (err) {
      console.error("Custom analysis error:", err);
      setError(err.message);
    } finally {
      setCustomLoading(false);
    }
  };

  return (
    <div className="ai-suggestion-list">
      <div className="custom-token-form">
        <input
          type="text"
          placeholder="Enter token symbol (e.g., LPT)"
          value={customSymbol}
          onChange={(e) => setCustomSymbol(e.target.value)}
        />
        <button
          disabled={!customSymbol || customLoading}
          onClick={handleAnalyze}
        >
          {customLoading ? "Analyzing..." : "Analyze"}
        </button>
      </div>

      {error && <p className="error-message">{error}</p>}

      {result && (
        <div className="single-suggestion-box enhanced-layout">
          <div className="header-row">
            <h4>
              <FontAwesomeIcon icon={faChartLine} /> {result.token} ($
              {result.priceAtAnalysis})
            </h4>
            <h4
              className={
                result.analysis.trendStrength?.toLowerCase() === "bullish"
                  ? "green-text"
                  : "red-text"
              }
            >
              {result.analysis.trendStrength}
            </h4>
            <div className="top-row-text-ai-2">{result.analysis.recommendation}</div>
            <div className="top-row-text-ai-2">
              <strong>Confidence:</strong> {result.analysis.confidenceLevel}/10
            </div>
            <div className="top-row-text-ai-2">
              <strong>Upside:</strong> ${result.analysis.upsideTarget} (
              {result.analysis.upsideChance})
            </div>
            <div className="top-row-text-ai-2">
              <strong>Downside:</strong> ${result.analysis.downsideRisk} (
              {result.analysis.downsideChance})
            </div>
          </div>

          <div className="expanded-section">
            {result.analysis.chartPattern !== "None" && (
              <div className="top-row-text-ai-3">
                <strong>Pattern:</strong> {result.analysis.chartPattern}
              </div>
            )}
            <div className="top-row-text-ai-3">
              <strong>MACD:</strong> {result.analysis.macd}
            </div>
            <div className="top-row-text-ai-3">
              <strong>RSI:</strong> {result.analysis.rsi}
            </div>
            <div className="top-row-text-ai-3">
              <strong>Volume:</strong> {result.analysis.volume}
             </div>
            {result.analysis.catalysts &&
              result.analysis.catalysts !== "None" && (
                <div className="top-row-text-ai-3">
                  <strong>Catalysts:</strong> {result.analysis.catalysts}
                 </div>
              )}
             <div className="top-row-text-ai-3">
              <strong>Justification:</strong> {result.analysis.justification}
            </div>
          </div>

          {/* ✅ Now safe to derive trend & display logic */}
<div className="options-container">
  {(() => {
    const trend = result.analysis.trendStrength?.toLowerCase();
    const isBullish = trend === "bullish";
    const isBearish = trend === "bearish";
    const short = result.analysis.shortPosition;
    const long = result.analysis.longPosition;

    const longClass = isBullish
      ? "long-short-block highlighted-block"
      : isBearish
      ? "long-short-block warning-block"
      : "long-short-block";

    const shortClass = isBearish
      ? "long-short-block highlighted-block"
      : isBullish
      ? "long-short-block warning-block"
      : "long-short-block";

    return (
      <>
        {long && (
          <div className={longClass}>
            <div className="top-row-text-ai-1">📈 Long Position</div>
            <div className="top-row-text-ai-1"><strong>Entry:</strong> ${long.entry}</div>
            <div className="top-row-text-ai-1"><strong>TP:</strong> ${long.tp}</div>
            <div className="top-row-text-ai-1"><strong>SL:</strong> ${long.sl}</div>
            <div className="top-row-text-ai-1"><strong>Risk:Reward:</strong> {long.riskReward}</div>
          </div>
        )}

        {short && (
          <div className={shortClass}>
            <div className="top-row-text-ai-1">📉 Short Position</div>
            <div className="top-row-text-ai-1"><strong>Entry:</strong> ${short.entry}</div>
            <div className="top-row-text-ai-1"><strong>TP:</strong> ${short.tp}</div>
            <div className="top-row-text-ai-1"><strong>SL:</strong> ${short.sl}</div>
            <div className="top-row-text-ai-1"><strong>Risk:Reward:</strong> {short.riskReward}</div>
          </div>
        )}
      </>
    );
  })()}
</div>


        </div>
      )}
    </div>
  );
}

export default CustomTokenAnalyzer;
